import { axios } from "../lib/axios";

export const createDentist = (dentist) => axios.post("dentist", dentist);

export const getDentistFromUserId = (userId) =>
  axios.get("dentist/user/" + userId);

export const getDentistHasChangedPassword = (userId) =>
  axios.get("dentist/user/" + userId + "/changed-password");

export const getDentists = () => axios.get("dentist");

export const getAllDentalClinics = () =>
  axios.get("dentist/getalldentalclinics");
